module.exports = __webpack_public_path__ + "img/red_044.fc314d9a.png";